// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Smart form chat panel — adapted from smartform_test */
.smart-form-panel {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}
.smart-form-panel--floating {
  position: fixed;
  z-index: 1000;
  min-width: 280px;
  min-height: 320px;
  box-shadow: 0 8px 24px rgba(26, 35, 50, 0.12), 0 2px 8px rgba(26, 35, 50, 0.08);
}
.smart-form-panel.is-resizing {
  -webkit-user-select: none;
  user-select: none;
}
.survey-panel-side {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 1.5rem;
  min-height: calc(100vh - 200px);
  position: relative;
}
.survey-panel-full {
  width: 100%;
}
/*
 * Keep the survey to the right of the default 400px assistant (12px viewport
 * offset + 24px breathing room). At 2400px there is enough room to center the
 * full 1500px form again without the two surfaces overlapping.
 */
@media (min-width: 961px) and (max-width: 2399px) {
  .app-main:has(.survey-panel-full) {
    margin-left: auto;
    margin-right: 0;
    max-width: min(1500px, calc(100% - 436px));
  }
}
@media (max-width: 960px) {
  .app-main:has(.survey-panel-full) {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
  }
}
.chat-panel-title {
  margin: 0;
  padding: 12px 16px;
  font-size: 1.125rem;
  font-weight: 600;
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: grab;
  -webkit-user-select: none;
  user-select: none;
  touch-action: none;
  background: var(--color-bg);
}
.smart-form-panel.is-dragging .chat-panel-title {
  cursor: grabbing;
}
.chat-panel-drag-handle {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  background: radial-gradient(circle, var(--color-text-muted) 1.5px, transparent 1.5px) 0 0 / 7px 7px;
  opacity: 0.55;
}
.chat-panel-resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: nwse-resize;
  touch-action: none;
  z-index: 2;
}
.chat-panel-resize-handle::before {
  content: '';
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 10px;
  height: 10px;
  border-right: 2px solid var(--color-text-muted);
  border-bottom: 2px solid var(--color-text-muted);
  opacity: 0.55;
  border-bottom-right-radius: 2px;
}
.chat-messages {
  flex: 3;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.chat-input-area {
  flex: 1;
  min-height: 0;
  padding: 12px 16px 16px;
  border-top: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.chat-input-area textarea {
  flex: 1;
  min-height: 60px;
  resize: none;
  width: 100%;
  padding: 12px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  font: inherit;
  font-family: inherit;
}
.chat-input-area textarea:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-light);
}
.chat-input-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.btn-secondary.listening,
.btn-secondary.listening:hover:not(:disabled) {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}
.status-text {
  min-height: 1.25rem;
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.85rem;
}
.chat-bubble-row {
  display: flex;
  width: 100%;
}
.chat-bubble-row.user {
  justify-content: flex-end;
}
.chat-bubble-row.assistant,
.chat-bubble-row.error,
.chat-bubble-row.loading {
  justify-content: flex-start;
}
.chat-bubble {
  max-width: 92%;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 0.95rem;
  line-height: 1.45;
}
.chat-bubble.user {
  background: var(--color-primary);
  color: #fff;
  border-bottom-right-radius: 4px;
}
.chat-bubble.assistant {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: var(--color-text);
  border-bottom-left-radius: 4px;
}
.chat-bubble.error {
  background: var(--color-error-bg);
  border: 1px solid #fecaca;
  color: var(--color-error);
  border-bottom-left-radius: 4px;
}
.chat-bubble.loading {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: var(--color-text-muted);
  border-bottom-left-radius: 4px;
}
.chat-bubble .bubble-prompt {
  margin: 0 0 8px;
}
.chat-bubble .bubble-prompt:last-child {
  margin-bottom: 0;
}
.chat-bubble .bubble-summary {
  margin: 0 0 8px;
  font-size: 0.9rem;
  color: var(--color-text-muted);
}
.chat-bubble.user .bubble-empty-start {
  font-style: italic;
  opacity: 0.9;
}
.bubble-followups {
  margin-top: 10px;
  padding: 10px;
  border-radius: var(--radius);
  background: #fffbeb;
  border: 1px solid #fde68a;
}
.bubble-followups.clarify {
  background: #fff7ed;
  border-color: #fed7aa;
}
.bubble-followups.bubble-collapsible {
  padding: 8px 10px;
}
.bubble-followups.bubble-collapsible .bubble-collapsible-toggle {
  color: #92400e;
}
.bubble-followups.clarify.bubble-collapsible .bubble-collapsible-toggle {
  color: #9a3412;
}
.bubble-followup-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.bubble-followup-item {
  margin-bottom: 6px;
}
.bubble-followup-item:last-child {
  margin-bottom: 0;
}
.bubble-followups-more {
  margin: 10px 0 0;
  font-size: 0.8rem;
  color: var(--color-text-muted);
  line-height: 1.4;
}
.bubble-followup-link {
  display: block;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.7);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  line-height: 1.45;
  white-space: normal;
  word-break: break-word;
}
.bubble-followup-link:hover {
  background: #fff;
}
.field-badge {
  display: inline-block;
  margin-right: 6px;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  vertical-align: middle;
}
.field-badge.required {
  background: #fef2f2;
  color: #b91c1c;
}
.field-badge.clarify {
  background: #fffbeb;
  color: #b45309;
}
.bubble-updates {
  margin-top: 10px;
}
.bubble-updates.bubble-collapsible .bubble-collapsible-toggle {
  color: #047857;
}
.bubble-collapsible {
  margin-top: 10px;
}
.bubble-collapsible-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}
.bubble-collapsible-toggle:hover {
  color: #0f172a;
}
.bubble-collapsible-chevron {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 6px solid currentColor;
  transition: transform 0.15s ease;
  flex-shrink: 0;
}
.bubble-collapsible-chevron.is-open {
  transform: rotate(90deg);
}
.bubble-collapsible-body {
  margin-top: 8px;
}
.bubble-updates-header {
  margin: 0 0 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #047857;
}
.bubble-update-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.bubble-update-chip {
  padding: 4px 10px;
  border: 1px solid #a7f3d0;
  border-radius: 999px;
  background: #ecfdf5;
  color: #065f46;
  font-size: 0.8rem;
  cursor: pointer;
  font-family: inherit;
}
.bubble-update-chip:hover {
  background: #d1fae5;
}
.bubble-requested-fields {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: var(--radius);
  padding: 8px 10px;
}
.bubble-requested-fields.bubble-collapsible {
  margin-top: 10px;
}
.bubble-requested-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.bubble-requested-chip {
  padding: 4px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1e40af;
  font-size: 0.8rem;
  cursor: pointer;
  font-family: inherit;
  line-height: 1.35;
  text-align: left;
}
.bubble-requested-chip:hover {
  background: #dbeafe;
}
.bubble-footer {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #e2e8f0;
}
.bubble-debug-toggle {
  padding: 0;
  border: none;
  background: none;
  color: #64748b;
  font-size: 0.8rem;
  cursor: pointer;
  text-decoration: underline;
  font-family: inherit;
}
.bubble-debug-toggle:hover {
  color: #334155;
}
.bubble-debug-meta {
  margin: 0 0 8px;
  font-size: 0.75rem;
  color: #64748b;
  word-break: break-all;
}
.bubble-debug-block + .bubble-debug-block {
  margin-top: 8px;
}
.bubble-debug-block h5 {
  margin: 0 0 4px;
  font-size: 0.75rem;
  color: #475569;
}
.bubble-debug-block pre {
  margin: 0;
  padding: 8px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.7rem;
  line-height: 1.35;
  overflow: auto;
  max-height: 200px;
  white-space: pre-wrap;
  word-break: break-word;
}
.survey-panel-side .field-highlight,
.survey-container .field-highlight {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius);
  transition: outline 0.2s;
}
.chat-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid #cbd5e1;
  border-top-color: #64748b;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: -2px;
  margin-right: 8px;
}
@media (max-width: 960px) {
  .survey-panel-side {
    min-height: 0;
  }
}
.attachment-confirm {
  margin-top: 16px;
  padding: 16px 20px;
  border: 1px solid #bae6fd;
  background: #f0f9ff;
  border-radius: var(--radius);
}
.attachment-confirm-title {
  margin: 0 0 10px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0c4a6e;
}
.attachment-list {
  list-style: none;
  margin: 0 0 12px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.attachment-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  color: #0f172a;
}
.attachment-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #16a34a;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  flex-shrink: 0;
}
.attachment-name {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  word-break: break-word;
}
.attachment-name small {
  margin-top: 2px;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 400;
}
.upload-target-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
  color: #334155;
  font-size: 0.875rem;
  font-weight: 600;
}
.upload-target-field select {
  min-height: 42px;
  padding: 8px 10px;
  border: 1px solid var(--color-border, #cbd5e1);
  border-radius: var(--radius);
  background: #fff;
  color: #0f172a;
  font: inherit;
  font-weight: 400;
}
.site-select-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 32rem;
  color: #334155;
  font-size: 0.875rem;
  font-weight: 600;
}
.site-select-field + .site-select-field {
  margin-top: 14px;
}
.site-select-field select {
  min-height: 42px;
  padding: 8px 10px;
  border: 1px solid var(--color-border, #cbd5e1);
  border-radius: var(--radius);
  background: #fff;
  color: #0f172a;
  font: inherit;
  font-weight: 400;
}
.site-select-field select.is-missing {
  border-color: #e0a1ab;
  background: #fff8f9;
}
.site-required {
  color: #b72b3e;
}
.pending-source-documents {
  margin-top: 16px;
  padding: 14px;
  border: 1px solid var(--color-border, #e2e8f0);
  border-radius: var(--radius);
  background: #f8fafc;
}
.pending-source-documents > strong {
  display: block;
  margin-bottom: 10px;
  font-size: 0.9rem;
}
.pending-source-documents .attachment-list {
  margin-bottom: 0;
}
.pending-document-remove {
  flex-shrink: 0;
  padding: 4px 8px;
}
.attachment-note {
  margin: 0;
  font-size: 0.85rem;
  color: #0c4a6e;
}
.attachment-actions {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}
/* ── Review & submit section ── */
.submit-review {
  margin-top: 20px;
  scroll-margin-top: 96px;
}
.submit-review-title {
  margin: 0 0 12px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #0f172a;
}
.review-card {
  margin-bottom: 16px;
  padding: 16px 20px;
  border: 1px solid var(--color-border, #e2e8f0);
  background: #fff;
  border-radius: var(--radius);
}
/* The attachment card keeps its blue treatment even as a review card. */
.review-card.attachment-confirm {
  margin-top: 0;
  border-color: #bae6fd;
  background: #f0f9ff;
}
.review-card-title {
  margin: 0 0 6px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
}
.review-card-note {
  margin: 0 0 14px;
  font-size: 0.85rem;
  color: var(--color-text-muted, #64748b);
}
.contact-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid var(--color-border, #e2e8f0);
  border-radius: var(--radius);
  background: #f8fafc;
}
.contact-item.is-excluded {
  opacity: 0.55;
}
.contact-include {
  display: flex;
  align-items: center;
  padding-top: 8px;
}
.contact-include input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.contact-fields {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.contact-user-picker {
  flex: none;
  align-self: center;
}
.contact-user-picker .site-user-picker-trigger {
  width: 34px;
  height: 34px;
}
.contact-input {
  flex: 1 1 140px;
  min-width: 120px;
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--color-border, #cbd5e1);
  border-radius: var(--radius);
  font-size: 0.9rem;
}
.contact-type {
  flex: 0 1 150px;
  background: #fff;
  cursor: pointer;
}
.contact-note {
  flex: 0 0 auto;
  padding: 3px 10px;
  border-radius: 999px;
  background: #e0e7ff;
  color: #3730a3;
  font-size: 0.75rem;
  font-weight: 600;
}
.contact-remove-btn {
  flex: 0 0 auto;
  margin-top: 4px;
  min-height: 34px;
  padding: 0 10px;
  border: 1px solid #e5a6a6;
  border-radius: var(--radius);
  background: #fff5f5;
  color: #a52828;
  font-size: 0.82rem;
  cursor: pointer;
}
.contact-list-actions {
  display: flex;
  margin-top: 12px;
}
/* ── Figma-aligned smart form experience ── */
.smart-form-panel {
  border-color: #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 10px 32px rgba(7, 51, 127, 0.12);
}
.smart-form-panel--floating {
  border-color: #c7d8eb;
  box-shadow: 0 18px 48px rgba(7, 51, 127, 0.18), 0 3px 10px rgba(7, 51, 127, 0.08);
}
.survey-panel-side {
  border-color: #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(7, 51, 127, 0.07);
}
.chat-panel-title {
  min-height: 70px;
  padding: 8px 16px;
  border-bottom-color: #d9e5f2;
  color: #07337f;
  background: linear-gradient(180deg, #f8fbff 0%, #eff6ff 100%);
  font-size: 0.95rem;
  font-weight: 700;
}
.smart-form-brand-icon-frame {
  display: inline-flex;
  width: 50px;
  height: 50px;
  flex: 0 0 50px;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  background: linear-gradient(135deg, #19f4e9 0%, #158df0 33%, #1a5fcc 67%, #220f8e 100%);
  box-shadow: 0 5px 12px rgba(7, 51, 127, 0.18);
}
.smart-form-brand-icon {
  position: relative;
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  border-radius: 40px;
  background: linear-gradient(135deg, #19f4e9 10%, #158df0 63%, #1a5fcc 67%, #220f8e 100%);
}
.smart-form-brand-owl {
  position: absolute;
  top: -18%;
  left: 50%;
  width: auto;
  max-width: none;
  height: 140%;
  object-fit: contain;
  transform: translateX(-40%) translateY(20%);
}
.smart-form-brand-star {
  position: absolute;
  z-index: 1;
  display: block;
  height: auto;
  pointer-events: none;
}
.smart-form-brand-star--large {
  top: 10px;
  left: -1px;
  width: 10px;
}
.smart-form-brand-star--small {
  top: 17px;
  left: 6px;
  width: 6px;
  opacity: 0.9;
}
.smart-form-title-copy {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 2px;
}
.smart-form-title-text {
  color: #07337f;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.25;
}
.smart-form-title-description {
  max-width: 460px;
  color: #68788e;
  font-size: 0.72rem;
  font-weight: 400;
  line-height: 1.35;
}
.chat-panel-drag-handle {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  opacity: 0.65;
  background: radial-gradient(circle, #2379f4 1.5px, transparent 1.5px) 0 0 / 7px 7px;
}
.chat-messages {
  gap: 14px;
  padding: 18px 16px;
  background: #f8fbff;
}
.chat-input-area {
  gap: 10px;
  padding: 14px 16px 16px;
  border-top-color: #d9e5f2;
  background: #ffffff;
}
.chat-input-area textarea {
  width: auto;
  min-width: 0;
  min-height: 42px;
  height: 100%;
  padding: 9px 11px;
  border-color: #c6d5e5;
  border-radius: 6px;
  color: #1d2b3c;
  background: #fff;
}
.chat-input-area textarea:focus {
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.15);
}
.chat-compose-row {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  height: 100%;
}
.microphone-button {
  width: 42px;
  min-width: 42px;
  height: 42px;
  min-height: 42px;
  padding: 0 !important;
  align-items: center;
  justify-content: center;
}
.textarea-mic-host {
  position: relative;
}
.textarea-mic-host > textarea {
  padding-right: 2.9rem;
  resize: vertical;
}
.textarea-mic-host.is-quill-field > textarea {
  display: none;
}
.textarea-field-tools {
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
}
.textarea-field-actions {
  position: absolute;
  right: 0.45rem;
  bottom: 0.45rem;
  z-index: 3;
  display: flex;
  gap: 0.3rem;
  pointer-events: auto;
}
.textarea-mic-host.is-quill-field .textarea-field-actions {
  top: 0.3rem;
  bottom: auto;
}
.textarea-tool-button {
  width: 34px;
  min-width: 34px;
  height: 34px;
  min-height: 34px;
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(7, 51, 127, 0.12);
}
.microphone-icon {
  width: 19px;
  height: 19px;
}
.textarea-tool-button .microphone-icon {
  width: 16px;
  height: 16px;
}
.textarea-mic-host > .ql-toolbar.ql-snow {
  border: 1px solid #cad7e4;
  border-bottom: 0;
  border-radius: 4px 4px 0 0;
  padding-right: 2.9rem;
  background: #ffffff;
}
.textarea-quill-wrap.ql-container.ql-snow {
  width: 100%;
  height: 9rem;
  min-height: 4rem;
  border: 1px solid #cad7e4;
  border-radius: 0 0 4px 4px;
  background: #ffffff;
  font: inherit;
  pointer-events: auto;
  overflow: hidden;
  padding-bottom: 13px;
}
.textarea-quill-wrap.ql-container.ql-snow .ql-editor {
  height: 100%;
  padding-bottom: 0.35rem;
}
.textarea-quill-wrap.ql-container.ql-snow > .textarea-quill-resize {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 13px;
  border-radius: 0 0 4px 4px;
  background: #f7fafd;
  cursor: ns-resize;
  pointer-events: auto;
  touch-action: none;
}
.textarea-quill-wrap.ql-container.ql-snow > .textarea-quill-resize::after {
  width: 30px;
  height: 3px;
  border-radius: 2px;
  background: #c3d2e2;
  content: '';
}
.textarea-quill-wrap.ql-container.ql-snow > .textarea-quill-resize:hover::after,
.textarea-quill-wrap.ql-container.ql-snow > .textarea-quill-resize.is-dragging::after {
  background: #2379f4;
}
.submit-icon-button {
  width: 42px;
  min-width: 42px;
  height: 42px;
  min-height: 42px;
  margin-left: auto;
  padding: 0 !important;
  align-items: center;
  justify-content: center;
}
.submit-icon {
  width: 19px;
  height: 19px;
}
.status-text {
  color: #68788e;
}
.chat-bubble {
  max-width: 92%;
  padding: 11px 13px;
  border-radius: 11px;
  color: #1d2b3c;
  font-size: 0.84rem;
  line-height: 1.48;
}
.chat-bubble.user {
  color: #fff;
  background: #2379f4;
  border-bottom-right-radius: 3px;
  box-shadow: 0 4px 12px rgba(35, 121, 244, 0.16);
}
.chat-bubble.assistant {
  border: 1px solid #d9e5f2;
  border-bottom-left-radius: 3px;
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(7, 51, 127, 0.06);
}
.chat-bubble.error {
  border-color: #ffc8cf;
  color: #a92032;
  background: #fff1f3;
}
.chat-bubble.loading {
  border: 1px solid #d9e5f2;
  background: #ffffff;
}
.bubble-followups,
.bubble-updates,
.bubble-requested-fields {
  border-color: #d9e5f2;
  border-radius: 6px;
  background: #f7faff;
}
.bubble-followup-link,
.bubble-collapsible-toggle {
  color: #2379f4;
}
.bubble-followup-link:hover,
.bubble-collapsible-toggle:hover {
  color: #1267dc;
}
.field-badge,
.bubble-update-chip,
.bubble-requested-chip {
  border-color: #c8d9ed;
  border-radius: 999px;
  color: #31557f;
  background: #edf5ff;
}
.field-badge.required {
  border-color: #ffd2d8;
  color: #b72b3e;
  background: #fff0f2;
}
.field-badge.clarify {
  border-color: #f8db9c;
  color: #8b5a08;
  background: #fff8e8;
}
.bubble-debug-toggle {
  color: #68788e;
}
.bubble-debug-toggle:hover {
  color: #2379f4;
}
.bubble-debug-panel,
.bubble-debug-block pre {
  border: 1px solid #d9e5f2;
  border-radius: 6px;
  background: #f5f8fc;
}
.survey-panel-side .sd-root-modern {
  --sjs-primary-backcolor: #2379f4;
  --sjs-primary-backcolor-dark: #1267dc;
  --sjs-primary-backcolor-light: #e9f3ff;
  --sjs-general-backcolor: #ffffff;
  --sjs-general-forecolor: #1d2b3c;
  --sjs-secondary-backcolor: #edf7ff;
  --sjs-border-default: #d9e5f2;
  --sjs-font-family: var(--font);
}
.survey-panel-side .field-highlight {
  outline-color: #2379f4;
  box-shadow: 0 0 0 4px rgba(35, 121, 244, 0.12);
}
.submit-review {
  margin-top: 24px;
}
.submit-review-title {
  color: #1d2b3c;
  font-size: 1.05rem;
}
.review-card {
  border-color: #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 5px 18px rgba(7, 51, 127, 0.05);
}
.contact-item {
  border-color: #d9e5f2;
  border-radius: 6px;
  background: #f8fbff;
}
.contact-input {
  border-color: #c5d4e4;
  border-radius: 6px;
}
.contact-input:focus {
  outline: none;
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.14);
}
.contact-note {
  color: #225c9b;
  background: #e5f1ff;
}
.attachment-confirm,
.review-card.attachment-confirm {
  border-color: #b7d7f7;
  border-radius: 10px;
  background: #eef7ff;
}
.attachment-confirm-title,
.attachment-note {
  color: #07337f;
}
.attachment-check {
  background: #18833d;
}
@media (max-width: 960px) {
  .smart-form-panel--floating {
    position: relative !important;
    inset: auto !important;
    width: 100% !important;
    height: min(560px, 72vh) !important;
    min-width: 0;
    margin-bottom: 1rem;
  }
  .chat-panel-title {
    cursor: default;
  }
  .chat-panel-drag-handle,
  .chat-panel-resize-handle {
    display: none;
  }
  .survey-panel-side {
    padding: 1rem;
  }
}
@media (max-width: 680px) {
  .survey-panel-side.survey-panel-full {
    padding: 0.35rem 0.2rem;
  }
  .survey-panel-side .sd-body.sd-body--responsive {
    padding: 0;
  }
}
@media (max-width: 600px) {
  .smart-form-panel--floating {
    height: min(500px, 68vh) !important;
  }
  .chat-compose-row {
    gap: 6px;
  }
  .contact-item {
    flex-wrap: wrap;
    gap: 8px;
  }
  .contact-remove-btn {
    margin-left: auto;
  }
  .contact-fields {
    display: grid;
    grid-template-columns: auto 1fr;
  }
  .contact-user-picker {
    grid-row: 1;
    align-self: start;
  }
  .contact-input {
    grid-column: 2;
    width: 100%;
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/smart-form.less"],"names":[],"mappings":"AAAA,wDAAwD;AAaxD;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AAXF;AAcA;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,+EAAA;AAZF;AAiBA;EACE,yBAAA;EACA,iBAAA;AAfF;AAkBA;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;AAhBF;AAmBA;EACE,WAAA;AAjBF;AACA;;;;EAIE;AAoBF;EACE;IACE,iBAAA;IACA,eAAA;IACA,0CAAA;EAlBF;AACF;AAqBA;EACE;IACE,cAAA;IACA,eAAA;IACA,eAAA;EAnBF;AACF;AAsBA;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;AApBF;AAuBA;EACE,gBAAA;AArBF;AAwBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mGAAA;EAEA,aAAA;AAvBF;AA0BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAxBF;AA2BA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,+CAAA;EACA,gDAAA;EACA,aAAA;EACA,+BAAA;AAzBF;AA4BA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA1BF;AA6BA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA3BF;AA8BA;EACE,OAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,4BAAA;EACA,aAAA;EACA,oBAAA;AA5BF;AA+BA;EACE,aAAA;EACA,kCAAA;EACA,gDAAA;AA7BF;AAgCA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA9BF;AAiCA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA/BF;AAkCA;;EAEE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhCF;AAmCA;EACE,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,kBAAA;AAjCF;AAoCA;EACE,aAAA;EACA,WAAA;AAlCF;AAqCA;EACE,yBAAA;AAnCF;AAsCA;;;EAGE,2BAAA;AApCF;AAuCA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AArCF;AAwCA;EACE,gCAAA;EACA,WAAA;EACA,+BAAA;AAtCF;AAyCA;EACE,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8BAAA;AAvCF;AA0CA;EACE,iCAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;AAxCF;AA2CA;EACE,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;AAzCF;AA4CA;EACE,eAAA;AA1CF;AA6CA;EACE,gBAAA;AA3CF;AA8CA;EACE,eAAA;EACA,iBAAA;EACA,8BAAA;AA5CF;AA+CA;EACE,kBAAA;EACA,YAAA;AA7CF;AAgDA;EACE,gBAAA;EACA,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;AA9CF;AAiDA;EACE,mBAAA;EACA,qBAAA;AA/CF;AAkDA;EACE,iBAAA;AAhDF;AAmDA;EACE,cAAA;AAjDF;AAoDA;EACE,cAAA;AAlDF;AAqDA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AAnDF;AAsDA;EACE,kBAAA;AApDF;AAuDA;EACE,gBAAA;AArDF;AAwDA;EACE,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gBAAA;AAtDF;AAyDA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;AAvDF;AA0DA;EACE,gBAAA;AAxDF;AA2DA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAzDF;AA4DA;EACE,mBAAA;EACA,cAAA;AA1DF;AA6DA;EACE,mBAAA;EACA,cAAA;AA3DF;AA8DA;EACE,gBAAA;AA5DF;AA+DA;EACE,cAAA;AA7DF;AAgEA;EACE,gBAAA;AA9DF;AAiEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AA/DF;AAkEA;EACE,cAAA;AAhEF;AAmEA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EACA,cAAA;AAjEF;AAoEA;EACE,wBAAA;AAlEF;AAqEA;EACE,eAAA;AAnEF;AAsEA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AApEF;AAuEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AArEF;AAwEA;EACE,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AAtEF;AAyEA;EACE,mBAAA;AAvEF;AA0EA;EACE,mBAAA;EACA,yBAAA;EACA,4BAAA;EACA,iBAAA;AAxEF;AA2EA;EACE,gBAAA;AAzEF;AA4EA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA1EF;AA6EA;EACE,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AA3EF;AA8EA;EACE,mBAAA;AA5EF;AA+EA;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;AA7EF;AAgFA;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,0BAAA;EACA,oBAAA;AA9EF;AAiFA;EACE,cAAA;AA/EF;AAkFA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAhFF;AAmFA;EACE,eAAA;AAjFF;AAoFA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AAlFF;AAqFA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAnFF;AAsFA;;EAEE,uCAAA;EACA,mBAAA;EACA,4BAAA;EACA,wBAAA;AApFF;AAuFA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,oBAAA;EACA,iBAAA;AArFF;AAwFA;EACE;IACE,aAAA;EAtFF;AACF;AAyFA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;AAvFF;AA0FA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAxFF;AA2FA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAzFF;AA4FA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AA1FF;AA6FA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AA3FF;AA8FA;EACE,aAAA;EACA,OAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;AA5FF;AAuFA;EAQI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA5FJ;AAgGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA9FF;AAuFA;EAUI,gBAAA;EACA,iBAAA;EACA,8CAAA;EACA,4BAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AA9FJ;AAkGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAhGF;AAkGE;EACE,gBAAA;AAhGJ;AAsFA;EAcI,gBAAA;EACA,iBAAA;EACA,8CAAA;EACA,4BAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AAjGJ;AA4EA;EAyBI,qBAAA;EACA,mBAAA;AAlGJ;AAsGA;EACE,cAAA;AApGF;AAuGA;EACE,gBAAA;EACA,aAAA;EACA,8CAAA;EACA,4BAAA;EACA,mBAAA;AArGF;AAgGA;EAQI,cAAA;EACA,mBAAA;EACA,iBAAA;AArGJ;AA2FA;EAcI,gBAAA;AAtGJ;AA0GA;EACE,cAAA;EACA,gBAAA;AAxGF;AA2GA;EACE,SAAA;EACA,kBAAA;EACA,cAAA;AAzGF;AA4GA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;AA1GF;AACA,kCAAkC;AA8GlC;EACE,gBAAA;EACA,uBAAA;AA5GF;AA+GA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AA7GF;AAgHA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EACA,gBAAA;EACA,4BAAA;AA9GF;AACA,wEAAwE;AAiHxE;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AA/GF;AAkHA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAhHF;AAmHA;EACE,gBAAA;EACA,kBAAA;EACA,uCAAA;AAjHF;AAoHA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAlHF;AAqHA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,8CAAA;EACA,4BAAA;EACA,mBAAA;AAnHF;AAsHA;EACE,aAAA;AApHF;AAuHA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AArHF;AAwHA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAtHF;AAyHA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;AAvHF;AA0HA;EACE,UAAA;EACA,kBAAA;AAxHF;AAsHA;EAKI,WAAA;EACA,YAAA;AAxHJ;AA4HA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,8CAAA;EACA,4BAAA;EACA,iBAAA;AA1HF;AA6HA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AA3HF;AA8HA;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA5HF;AA+HA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AA7HF;AAgIA;EACE,aAAA;EACA,gBAAA;AA9HF;AACA,8CAA8C;AAkI9C;EACE,qBAAA;EACA,mBAAA;EACA,8CAAA;AAhIF;AAmIA;EACE,qBAAA;EACA,iFAAA;AAjIF;AAsIA;EACE,qBAAA;EACA,mBAAA;EACA,6CAAA;AApIF;AAuIA;EACE,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,6DAAA;EACA,kBAAA;EACA,gBAAA;AArIF;AAwIA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uFAAA;EACA,6CAAA;AAtIF;AAyIA;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wFAAA;AAvIF;AA0IA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;AAxIF;AA2IA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;AAzIF;AA4IA;EACE,SAAA;EACA,UAAA;EACA,WAAA;AA1IF;AA6IA;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA3IF;AA8IA;EACE,aAAA;EACA,YAAA;EACA,OAAA;EACA,sBAAA;EACA,QAAA;AA5IF;AA+IA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA7IF;AAgJA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA9IF;AAiJA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mFAAA;AA/IF;AAmJA;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;AAjJF;AAoJA;EACE,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AAlJF;AA8IA;EAOI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAlJJ;AAoJI;EACE,qBAAA;EACA,8CAAA;AAlJN;AAuJA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AArJF;AAwJA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AAtJF;AAyJA;EACE,kBAAA;AAvJF;AA0JA;EACE,qBAAA;EACA,gBAAA;AAxJF;AA2JA;EACE,aAAA;AAzJF;AA4JA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;AA1JF;AA6JA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;AA3JF;AAgKA;EACE,WAAA;EACA,YAAA;AA9JF;AAiKA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,4CAAA;AA/JF;AAkKA;EACE,WAAA;EACA,YAAA;AAhKF;AAmKA;EACE,WAAA;EACA,YAAA;AAjKF;AAsKA;EACE,yBAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,mBAAA;AApKF;AAuKA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EAEA,oBAAA;AAtKF;AA2JA;EAcI,YAAA;EACA,uBAAA;AAtKJ;AA0KA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAxKF;AA0KE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAxKJ;AA2KE;;EAEE,mBAAA;AAzKJ;AA6KA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AA3KF;AA8KA;EACE,WAAA;EACA,YAAA;AA5KF;AA+KA;EACE,cAAA;AA7KF;AAgLA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AA9KF;AAgLE;EACE,WAAA;EACA,mBAAA;EACA,+BAAA;EACA,+CAAA;AA9KJ;AAiLE;EACE,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6CAAA;AA/KJ;AAkLE;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;AAhLJ;AAmLE;EACE,yBAAA;EACA,mBAAA;AAjLJ;AAqLA;;;EAGE,qBAAA;EACA,kBAAA;EACA,mBAAA;AAnLF;AAsLA;;EAEE,cAAA;AApLF;AAsLE;;EACE,cAAA;AAnLJ;AAuLA;;;EAGE,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AArLF;AAwLA;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;AAtLF;AAyLA;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;AAvLF;AA0LA;EACE,cAAA;AAxLF;AA0LE;EACE,cAAA;AAxLJ;AA4LA;;EAEE,yBAAA;EACA,kBAAA;EACA,mBAAA;AA1LF;AA6LA;EAEI,gCAAA;EACA,qCAAA;EACA,sCAAA;EACA,gCAAA;EACA,gCAAA;EACA,kCAAA;EACA,6BAAA;EACA,8BAAA;AA5LJ;AAmLA;EAaI,sBAAA;EACA,8CAAA;AA7LJ;AAiMA;EACE,gBAAA;AA/LF;AAkMA;EACE,cAAA;EACA,kBAAA;AAhMF;AAmMA;EACE,qBAAA;EACA,mBAAA;EACA,6CAAA;AAjMF;AAoMA;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;AAlMF;AAqMA;EACE,qBAAA;EACA,kBAAA;AAnMF;AAqME;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAnMJ;AAuMA;EACE,cAAA;EACA,mBAAA;AArMF;AAwMA;;EAEE,qBAAA;EACA,mBAAA;EACA,mBAAA;AAtMF;AAyMA;;EAEE,cAAA;AAvMF;AA0MA;EACE,mBAAA;AAxMF;AA2MA;EACE;IACE,6BAAA;IACA,sBAAA;IACA,sBAAA;IACA,mCAAA;IACA,YAAA;IACA,mBAAA;EAzMF;EA4MA;IACE,eAAA;EA1MF;EA6MA;;IAEE,aAAA;EA3MF;EA8MA;IACE,aAAA;EA5MF;AACF;AA+MA;EACE;IACE,uBAAA;EA7MF;EAgNA;IACE,UAAA;EA9MF;AACF;AAiNA;EACE;IACE,mCAAA;EA/MF;EAkNA;IACE,QAAA;EAhNF;EAmNA;IACE,eAAA;IACA,QAAA;EAjNF;EAoNA;IACE,iBAAA;EAlNF;EAqNA;IACE,aAAA;IACA,+BAAA;EAnNF;EAsNA;IACE,WAAA;IACA,iBAAA;EApNF;EAuNA;IACE,cAAA;IACA,WAAA;IACA,YAAA;EArNF;AACF","sourcesContent":["/* Smart form chat panel — adapted from smartform_test */\n\n@primary: #2379f4;\n@primary-hover: #1267dc;\n@navy: #07337f;\n@border: #d9e5f2;\n@text: #1d2b3c;\n@muted: #68788e;\n@sky: #edf7ff;\n@surface: #ffffff;\n@radius: 6px;\n@radius-lg: 10px;\n\n.smart-form-panel {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  overflow: hidden;\n}\n\n.smart-form-panel--floating {\n  position: fixed;\n  z-index: 1000;\n  min-width: 280px;\n  min-height: 320px;\n  box-shadow:\n    0 8px 24px rgba(26, 35, 50, 0.12),\n    0 2px 8px rgba(26, 35, 50, 0.08);\n}\n\n.smart-form-panel.is-resizing {\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.survey-panel-side {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 1.5rem;\n  min-height: calc(100vh - 200px);\n  position: relative;\n}\n\n.survey-panel-full {\n  width: 100%;\n}\n\n/*\n * Keep the survey to the right of the default 400px assistant (12px viewport\n * offset + 24px breathing room). At 2400px there is enough room to center the\n * full 1500px form again without the two surfaces overlapping.\n */\n@media (min-width: 961px) and (max-width: 2399px) {\n  .app-main:has(.survey-panel-full) {\n    margin-left: auto;\n    margin-right: 0;\n    max-width: min(1500px, calc(100% - 436px));\n  }\n}\n\n@media (max-width: 960px) {\n  .app-main:has(.survey-panel-full) {\n    margin-left: 0;\n    margin-right: 0;\n    max-width: 100%;\n  }\n}\n\n.chat-panel-title {\n  margin: 0;\n  padding: 12px 16px;\n  font-size: 1.125rem;\n  font-weight: 600;\n  border-bottom: 1px solid var(--color-border);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: grab;\n  -webkit-user-select: none;\n  user-select: none;\n  touch-action: none;\n  background: var(--color-bg);\n}\n\n.smart-form-panel.is-dragging .chat-panel-title {\n  cursor: grabbing;\n}\n\n.chat-panel-drag-handle {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  background:\n    radial-gradient(circle, var(--color-text-muted) 1.5px, transparent 1.5px) 0 0 / 7px 7px;\n  opacity: 0.55;\n}\n\n.chat-panel-resize-handle {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: nwse-resize;\n  touch-action: none;\n  z-index: 2;\n}\n\n.chat-panel-resize-handle::before {\n  content: '';\n  position: absolute;\n  right: 4px;\n  bottom: 4px;\n  width: 10px;\n  height: 10px;\n  border-right: 2px solid var(--color-text-muted);\n  border-bottom: 2px solid var(--color-text-muted);\n  opacity: 0.55;\n  border-bottom-right-radius: 2px;\n}\n\n.chat-messages {\n  flex: 3;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.chat-input-area {\n  flex: 1;\n  min-height: 0;\n  padding: 12px 16px 16px;\n  border-top: 1px solid var(--color-border);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.chat-input-area textarea {\n  flex: 1;\n  min-height: 60px;\n  resize: none;\n  width: 100%;\n  padding: 12px;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  font: inherit;\n  font-family: inherit;\n}\n\n.chat-input-area textarea:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-light);\n}\n\n.chat-input-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.btn-secondary.listening,\n.btn-secondary.listening:hover:not(:disabled) {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.status-text {\n  min-height: 1.25rem;\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.85rem;\n}\n\n.chat-bubble-row {\n  display: flex;\n  width: 100%;\n}\n\n.chat-bubble-row.user {\n  justify-content: flex-end;\n}\n\n.chat-bubble-row.assistant,\n.chat-bubble-row.error,\n.chat-bubble-row.loading {\n  justify-content: flex-start;\n}\n\n.chat-bubble {\n  max-width: 92%;\n  padding: 10px 14px;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  line-height: 1.45;\n}\n\n.chat-bubble.user {\n  background: var(--color-primary);\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n\n.chat-bubble.assistant {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  color: var(--color-text);\n  border-bottom-left-radius: 4px;\n}\n\n.chat-bubble.error {\n  background: var(--color-error-bg);\n  border: 1px solid #fecaca;\n  color: var(--color-error);\n  border-bottom-left-radius: 4px;\n}\n\n.chat-bubble.loading {\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  color: var(--color-text-muted);\n  border-bottom-left-radius: 4px;\n}\n\n.chat-bubble .bubble-prompt {\n  margin: 0 0 8px;\n}\n\n.chat-bubble .bubble-prompt:last-child {\n  margin-bottom: 0;\n}\n\n.chat-bubble .bubble-summary {\n  margin: 0 0 8px;\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.chat-bubble.user .bubble-empty-start {\n  font-style: italic;\n  opacity: 0.9;\n}\n\n.bubble-followups {\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: var(--radius);\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n}\n\n.bubble-followups.clarify {\n  background: #fff7ed;\n  border-color: #fed7aa;\n}\n\n.bubble-followups.bubble-collapsible {\n  padding: 8px 10px;\n}\n\n.bubble-followups.bubble-collapsible .bubble-collapsible-toggle {\n  color: #92400e;\n}\n\n.bubble-followups.clarify.bubble-collapsible .bubble-collapsible-toggle {\n  color: #9a3412;\n}\n\n.bubble-followup-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.bubble-followup-item {\n  margin-bottom: 6px;\n}\n\n.bubble-followup-item:last-child {\n  margin-bottom: 0;\n}\n\n.bubble-followups-more {\n  margin: 10px 0 0;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  line-height: 1.4;\n}\n\n.bubble-followup-link {\n  display: block;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.7);\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  line-height: 1.45;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.bubble-followup-link:hover {\n  background: #fff;\n}\n\n.field-badge {\n  display: inline-block;\n  margin-right: 6px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n.field-badge.required {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.field-badge.clarify {\n  background: #fffbeb;\n  color: #b45309;\n}\n\n.bubble-updates {\n  margin-top: 10px;\n}\n\n.bubble-updates.bubble-collapsible .bubble-collapsible-toggle {\n  color: #047857;\n}\n\n.bubble-collapsible {\n  margin-top: 10px;\n}\n\n.bubble-collapsible-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n}\n\n.bubble-collapsible-toggle:hover {\n  color: #0f172a;\n}\n\n.bubble-collapsible-chevron {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 6px solid currentColor;\n  transition: transform 0.15s ease;\n  flex-shrink: 0;\n}\n\n.bubble-collapsible-chevron.is-open {\n  transform: rotate(90deg);\n}\n\n.bubble-collapsible-body {\n  margin-top: 8px;\n}\n\n.bubble-updates-header {\n  margin: 0 0 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #047857;\n}\n\n.bubble-update-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.bubble-update-chip {\n  padding: 4px 10px;\n  border: 1px solid #a7f3d0;\n  border-radius: 999px;\n  background: #ecfdf5;\n  color: #065f46;\n  font-size: 0.8rem;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.bubble-update-chip:hover {\n  background: #d1fae5;\n}\n\n.bubble-requested-fields {\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n  border-radius: var(--radius);\n  padding: 8px 10px;\n}\n\n.bubble-requested-fields.bubble-collapsible {\n  margin-top: 10px;\n}\n\n.bubble-requested-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.bubble-requested-chip {\n  padding: 4px 10px;\n  border: 1px solid #bfdbfe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1e40af;\n  font-size: 0.8rem;\n  cursor: pointer;\n  font-family: inherit;\n  line-height: 1.35;\n  text-align: left;\n}\n\n.bubble-requested-chip:hover {\n  background: #dbeafe;\n}\n\n.bubble-footer {\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.bubble-debug-toggle {\n  padding: 0;\n  border: none;\n  background: none;\n  color: #64748b;\n  font-size: 0.8rem;\n  cursor: pointer;\n  text-decoration: underline;\n  font-family: inherit;\n}\n\n.bubble-debug-toggle:hover {\n  color: #334155;\n}\n\n.bubble-debug-meta {\n  margin: 0 0 8px;\n  font-size: 0.75rem;\n  color: #64748b;\n  word-break: break-all;\n}\n\n.bubble-debug-block + .bubble-debug-block {\n  margin-top: 8px;\n}\n\n.bubble-debug-block h5 {\n  margin: 0 0 4px;\n  font-size: 0.75rem;\n  color: #475569;\n}\n\n.bubble-debug-block pre {\n  margin: 0;\n  padding: 8px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  line-height: 1.35;\n  overflow: auto;\n  max-height: 200px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.survey-panel-side .field-highlight,\n.survey-container .field-highlight {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n  border-radius: var(--radius);\n  transition: outline 0.2s;\n}\n\n.chat-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid #cbd5e1;\n  border-top-color: #64748b;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  vertical-align: -2px;\n  margin-right: 8px;\n}\n\n@media (max-width: 960px) {\n  .survey-panel-side {\n    min-height: 0;\n  }\n}\n\n.attachment-confirm {\n  margin-top: 16px;\n  padding: 16px 20px;\n  border: 1px solid #bae6fd;\n  background: #f0f9ff;\n  border-radius: var(--radius);\n}\n\n.attachment-confirm-title {\n  margin: 0 0 10px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #0c4a6e;\n}\n\n.attachment-list {\n  list-style: none;\n  margin: 0 0 12px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.attachment-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.9rem;\n  color: #0f172a;\n}\n\n.attachment-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #16a34a;\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.attachment-name {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n  word-break: break-word;\n\n  small {\n    margin-top: 2px;\n    color: #64748b;\n    font-size: 0.75rem;\n    font-weight: 400;\n  }\n}\n\n.upload-target-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 16px;\n  color: #334155;\n  font-size: 0.875rem;\n  font-weight: 600;\n\n  select {\n    min-height: 42px;\n    padding: 8px 10px;\n    border: 1px solid var(--color-border, #cbd5e1);\n    border-radius: var(--radius);\n    background: #fff;\n    color: #0f172a;\n    font: inherit;\n    font-weight: 400;\n  }\n}\n\n.site-select-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 32rem;\n  color: #334155;\n  font-size: 0.875rem;\n  font-weight: 600;\n\n  & + & {\n    margin-top: 14px;\n  }\n\n  select {\n    min-height: 42px;\n    padding: 8px 10px;\n    border: 1px solid var(--color-border, #cbd5e1);\n    border-radius: var(--radius);\n    background: #fff;\n    color: #0f172a;\n    font: inherit;\n    font-weight: 400;\n  }\n\n  select.is-missing {\n    border-color: #e0a1ab;\n    background: #fff8f9;\n  }\n}\n\n.site-required {\n  color: #b72b3e;\n}\n\n.pending-source-documents {\n  margin-top: 16px;\n  padding: 14px;\n  border: 1px solid var(--color-border, #e2e8f0);\n  border-radius: var(--radius);\n  background: #f8fafc;\n\n  > strong {\n    display: block;\n    margin-bottom: 10px;\n    font-size: 0.9rem;\n  }\n\n  .attachment-list {\n    margin-bottom: 0;\n  }\n}\n\n.pending-document-remove {\n  flex-shrink: 0;\n  padding: 4px 8px;\n}\n\n.attachment-note {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #0c4a6e;\n}\n\n.attachment-actions {\n  margin-top: 14px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* ── Review & submit section ── */\n\n.submit-review {\n  margin-top: 20px;\n  scroll-margin-top: 96px;\n}\n\n.submit-review-title {\n  margin: 0 0 12px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.review-card {\n  margin-bottom: 16px;\n  padding: 16px 20px;\n  border: 1px solid var(--color-border, #e2e8f0);\n  background: #fff;\n  border-radius: var(--radius);\n}\n\n/* The attachment card keeps its blue treatment even as a review card. */\n.review-card.attachment-confirm {\n  margin-top: 0;\n  border-color: #bae6fd;\n  background: #f0f9ff;\n}\n\n.review-card-title {\n  margin: 0 0 6px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.review-card-note {\n  margin: 0 0 14px;\n  font-size: 0.85rem;\n  color: var(--color-text-muted, #64748b);\n}\n\n.contact-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.contact-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border, #e2e8f0);\n  border-radius: var(--radius);\n  background: #f8fafc;\n}\n\n.contact-item.is-excluded {\n  opacity: 0.55;\n}\n\n.contact-include {\n  display: flex;\n  align-items: center;\n  padding-top: 8px;\n}\n\n.contact-include input {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.contact-fields {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.contact-user-picker {\n  flex: none;\n  align-self: center;\n\n  .site-user-picker-trigger {\n    width: 34px;\n    height: 34px;\n  }\n}\n\n.contact-input {\n  flex: 1 1 140px;\n  min-width: 120px;\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid var(--color-border, #cbd5e1);\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n}\n\n.contact-type {\n  flex: 0 1 150px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.contact-note {\n  flex: 0 0 auto;\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: #e0e7ff;\n  color: #3730a3;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.contact-remove-btn {\n  flex: 0 0 auto;\n  margin-top: 4px;\n  min-height: 34px;\n  padding: 0 10px;\n  border: 1px solid #e5a6a6;\n  border-radius: var(--radius);\n  background: #fff5f5;\n  color: #a52828;\n  font-size: 0.82rem;\n  cursor: pointer;\n}\n\n.contact-list-actions {\n  display: flex;\n  margin-top: 12px;\n}\n\n/* ── Figma-aligned smart form experience ── */\n\n.smart-form-panel {\n  border-color: @border;\n  border-radius: @radius-lg;\n  box-shadow: 0 10px 32px fade(@navy, 12%);\n}\n\n.smart-form-panel--floating {\n  border-color: #c7d8eb;\n  box-shadow:\n    0 18px 48px fade(@navy, 18%),\n    0 3px 10px fade(@navy, 8%);\n}\n\n.survey-panel-side {\n  border-color: @border;\n  border-radius: @radius-lg;\n  box-shadow: 0 8px 28px fade(@navy, 7%);\n}\n\n.chat-panel-title {\n  min-height: 70px;\n  padding: 8px 16px;\n  border-bottom-color: @border;\n  color: @navy;\n  background: linear-gradient(180deg, #f8fbff 0%, #eff6ff 100%);\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.smart-form-brand-icon-frame {\n  display: inline-flex;\n  width: 50px;\n  height: 50px;\n  flex: 0 0 50px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  background: linear-gradient(135deg, #19f4e9 0%, #158df0 33%, #1a5fcc 67%, #220f8e 100%);\n  box-shadow: 0 5px 12px fade(@navy, 18%);\n}\n\n.smart-form-brand-icon {\n  position: relative;\n  display: inline-flex;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  align-items: flex-end;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 40px;\n  background: linear-gradient(135deg, #19f4e9 10%, #158df0 63%, #1a5fcc 67%, #220f8e 100%)\n}\n\n.smart-form-brand-owl {\n  position: absolute;\n  top: -18%;\n  left: 50%;\n  width: auto;\n  max-width: none;\n  height: 140%;\n  object-fit: contain;\n  transform: translateX(-40%) translateY(20%);\n}\n\n.smart-form-brand-star {\n  position: absolute;\n  z-index: 1;\n  display: block;\n  height: auto;\n  pointer-events: none;\n}\n\n.smart-form-brand-star--large {\n  top: 10px;\n  left: -1px;\n  width: 10px;\n}\n\n.smart-form-brand-star--small {\n  top: 17px;\n  left: 6px;\n  width: 6px;\n  opacity: 0.9;\n}\n\n.smart-form-title-copy {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.smart-form-title-text {\n  color: @navy;\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.smart-form-title-description {\n  max-width: 460px;\n  color: @muted;\n  font-size: 0.72rem;\n  font-weight: 400;\n  line-height: 1.35;\n}\n\n.chat-panel-drag-handle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  opacity: 0.65;\n  background:\n    radial-gradient(circle, @primary 1.5px, transparent 1.5px) 0 0 / 7px 7px;\n}\n\n.chat-messages {\n  gap: 14px;\n  padding: 18px 16px;\n  background: #f8fbff;\n}\n\n.chat-input-area {\n  gap: 10px;\n  padding: 14px 16px 16px;\n  border-top-color: @border;\n  background: @surface;\n\n  textarea {\n    width: auto;\n    min-width: 0;\n    min-height: 42px;\n    height: 100%;\n    padding: 9px 11px;\n    border-color: #c6d5e5;\n    border-radius: @radius;\n    color: @text;\n    background: #fff;\n\n    &:focus {\n      border-color: @primary;\n      box-shadow: 0 0 0 3px fade(@primary, 15%);\n    }\n  }\n}\n\n.chat-compose-row {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 8px;\n  height: 100%;\n}\n\n.microphone-button {\n  width: 42px;\n  min-width: 42px;\n  height: 42px;\n  min-height: 42px;\n  padding: 0 !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.textarea-mic-host {\n  position: relative;\n}\n\n.textarea-mic-host > textarea {\n  padding-right: 2.9rem;\n  resize: vertical;\n}\n\n.textarea-mic-host.is-quill-field > textarea {\n  display: none;\n}\n\n.textarea-field-tools {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.textarea-field-actions {\n  position: absolute;\n  right: 0.45rem;\n  bottom: 0.45rem;\n  z-index: 3;\n  display: flex;\n  gap: 0.3rem;\n  pointer-events: auto;\n}\n\n// The drag strip runs along the bottom of a Quill field, so the mic button sits\n// in the toolbar row instead.\n.textarea-mic-host.is-quill-field .textarea-field-actions {\n  top: 0.3rem;\n  bottom: auto;\n}\n\n.textarea-tool-button {\n  width: 34px;\n  min-width: 34px;\n  height: 34px;\n  min-height: 34px;\n  border-radius: 999px;\n  box-shadow: 0 2px 8px fade(@navy, 12%);\n}\n\n.microphone-icon {\n  width: 19px;\n  height: 19px;\n}\n\n.textarea-tool-button .microphone-icon {\n  width: 16px;\n  height: 16px;\n}\n\n// Quill turns the element we hand it into .ql-container and inserts the toolbar\n// as a sibling before it, so both end up as children of the field host.\n.textarea-mic-host > .ql-toolbar.ql-snow {\n  border: 1px solid #cad7e4;\n  border-bottom: 0;\n  border-radius: 4px 4px 0 0;\n  padding-right: 2.9rem;\n  background: @surface;\n}\n\n.textarea-quill-wrap.ql-container.ql-snow {\n  width: 100%;\n  height: 9rem;\n  min-height: 4rem;\n  border: 1px solid #cad7e4;\n  border-radius: 0 0 4px 4px;\n  background: @surface;\n  font: inherit;\n  pointer-events: auto;\n  overflow: hidden;\n  // Leaves room for the drag strip so it never sits on top of the text.\n  padding-bottom: 13px;\n\n  .ql-editor {\n    height: 100%;\n    padding-bottom: 0.35rem;\n  }\n}\n\n.textarea-quill-wrap.ql-container.ql-snow > .textarea-quill-resize {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 13px;\n  border-radius: 0 0 4px 4px;\n  background: #f7fafd;\n  cursor: ns-resize;\n  pointer-events: auto;\n  touch-action: none;\n\n  &::after {\n    width: 30px;\n    height: 3px;\n    border-radius: 2px;\n    background: #c3d2e2;\n    content: '';\n  }\n\n  &:hover::after,\n  &.is-dragging::after {\n    background: @primary;\n  }\n}\n\n.submit-icon-button {\n  width: 42px;\n  min-width: 42px;\n  height: 42px;\n  min-height: 42px;\n  margin-left: auto;\n  padding: 0 !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.submit-icon {\n  width: 19px;\n  height: 19px;\n}\n\n.status-text {\n  color: @muted;\n}\n\n.chat-bubble {\n  max-width: 92%;\n  padding: 11px 13px;\n  border-radius: 11px;\n  color: @text;\n  font-size: 0.84rem;\n  line-height: 1.48;\n\n  &.user {\n    color: #fff;\n    background: @primary;\n    border-bottom-right-radius: 3px;\n    box-shadow: 0 4px 12px fade(@primary, 16%);\n  }\n\n  &.assistant {\n    border: 1px solid @border;\n    border-bottom-left-radius: 3px;\n    background: @surface;\n    box-shadow: 0 3px 10px fade(@navy, 6%);\n  }\n\n  &.error {\n    border-color: #ffc8cf;\n    color: #a92032;\n    background: #fff1f3;\n  }\n\n  &.loading {\n    border: 1px solid @border;\n    background: @surface;\n  }\n}\n\n.bubble-followups,\n.bubble-updates,\n.bubble-requested-fields {\n  border-color: @border;\n  border-radius: @radius;\n  background: #f7faff;\n}\n\n.bubble-followup-link,\n.bubble-collapsible-toggle {\n  color: @primary;\n\n  &:hover {\n    color: @primary-hover;\n  }\n}\n\n.field-badge,\n.bubble-update-chip,\n.bubble-requested-chip {\n  border-color: #c8d9ed;\n  border-radius: 999px;\n  color: #31557f;\n  background: #edf5ff;\n}\n\n.field-badge.required {\n  border-color: #ffd2d8;\n  color: #b72b3e;\n  background: #fff0f2;\n}\n\n.field-badge.clarify {\n  border-color: #f8db9c;\n  color: #8b5a08;\n  background: #fff8e8;\n}\n\n.bubble-debug-toggle {\n  color: @muted;\n\n  &:hover {\n    color: @primary;\n  }\n}\n\n.bubble-debug-panel,\n.bubble-debug-block pre {\n  border: 1px solid @border;\n  border-radius: @radius;\n  background: #f5f8fc;\n}\n\n.survey-panel-side {\n  .sd-root-modern {\n    --sjs-primary-backcolor: @primary;\n    --sjs-primary-backcolor-dark: @primary-hover;\n    --sjs-primary-backcolor-light: #e9f3ff;\n    --sjs-general-backcolor: @surface;\n    --sjs-general-forecolor: @text;\n    --sjs-secondary-backcolor: @sky;\n    --sjs-border-default: @border;\n    --sjs-font-family: var(--font);\n  }\n\n  .field-highlight {\n    outline-color: @primary;\n    box-shadow: 0 0 0 4px fade(@primary, 12%);\n  }\n}\n\n.submit-review {\n  margin-top: 24px;\n}\n\n.submit-review-title {\n  color: @text;\n  font-size: 1.05rem;\n}\n\n.review-card {\n  border-color: @border;\n  border-radius: @radius-lg;\n  box-shadow: 0 5px 18px fade(@navy, 5%);\n}\n\n.contact-item {\n  border-color: @border;\n  border-radius: @radius;\n  background: #f8fbff;\n}\n\n.contact-input {\n  border-color: #c5d4e4;\n  border-radius: @radius;\n\n  &:focus {\n    outline: none;\n    border-color: @primary;\n    box-shadow: 0 0 0 3px fade(@primary, 14%);\n  }\n}\n\n.contact-note {\n  color: #225c9b;\n  background: #e5f1ff;\n}\n\n.attachment-confirm,\n.review-card.attachment-confirm {\n  border-color: #b7d7f7;\n  border-radius: @radius-lg;\n  background: #eef7ff;\n}\n\n.attachment-confirm-title,\n.attachment-note {\n  color: @navy;\n}\n\n.attachment-check {\n  background: #18833d;\n}\n\n@media (max-width: 960px) {\n  .smart-form-panel--floating {\n    position: relative !important;\n    inset: auto !important;\n    width: 100% !important;\n    height: min(560px, 72vh) !important;\n    min-width: 0;\n    margin-bottom: 1rem;\n  }\n\n  .chat-panel-title {\n    cursor: default;\n  }\n\n  .chat-panel-drag-handle,\n  .chat-panel-resize-handle {\n    display: none;\n  }\n\n  .survey-panel-side {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 680px) {\n  .survey-panel-side.survey-panel-full {\n    padding: 0.35rem 0.2rem;\n  }\n\n  .survey-panel-side .sd-body.sd-body--responsive {\n    padding: 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .smart-form-panel--floating {\n    height: min(500px, 68vh) !important;\n  }\n\n  .chat-compose-row {\n    gap: 6px;\n  }\n\n  .contact-item {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .contact-remove-btn {\n    margin-left: auto;\n  }\n\n  .contact-fields {\n    display: grid;\n    grid-template-columns: auto 1fr;\n  }\n\n  .contact-user-picker {\n    grid-row: 1;\n    align-self: start;\n  }\n\n  .contact-input {\n    grid-column: 2;\n    width: 100%;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
